var _defs, _path, _circle, _path2, _circle2, _polyline, _polyline2, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.13px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Switch Shift Icon_2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1,13.67V11.76a.87.87,0,0,0-.86-.86h-5a.87.87,0,0,0-.86.86v1.91Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.73,
    cy: 8.01,
    r: 2.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64,9.17V7.26a.87.87,0,0,0-.86-.86h-5a.87.87,0,0,0-.86.86V9.17Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.27,
    cy: 3.5,
    r: 2.25
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.24 13.05 2.19 13.05 2.19 10.71"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8.31 1.89 12.36 1.89 12.36 4.23"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.14 1.92 8.94 3.19 8.94 0.64 7.14 1.92"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "7.32 13.08 5.52 11.81 5.52 14.36 7.32 13.08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.49267457b7845ccf964ccf55c06990b6.svg";
export { ForwardRef as ReactComponent };